import { useEffect, useState } from "react";

export const useFetchProductSettingsSkuOverrides = (distributorId) => {
    const [productSettingsSkuOverrides, setProductSettingsSkuOverrides] = useState(null);

    useEffect(() => {
        const fetchProductSettingsSkuOverrides = async () => {
            const rsp = await fetch(`api/products/byDistributor/${distributorId}`);
            const productSettingsSkuOverrides = await rsp.json();

            setProductSettingsSkuOverrides(productSettingsSkuOverrides);
        }
        fetchProductSettingsSkuOverrides();
    }, [distributorId])

    return productSettingsSkuOverrides;
}
